<template>
    <!-- mb5-temp -->
    <div class="row banner-section mb-5">
        <div class="banner-container" :style="{ height: bannerHeight + '!important' }">
            <img :src="imagePath" class="w-100 d-none d-md-block d-lg-block" alt="Banner Image" />
            <img :src="mobileImagePath" class="w-100" alt="Banner Image" />
        </div>
        <div class="bannerTextContainer p-2 d-flex flex-column justify-content" :style="{ top: textHeight + '!important' }">
            <div class="bannerCopy w-xs-100 w-sm-100">
                <p class="bannerTitle1 title-off mb-0">
                    <span class="d-md-inline-block font-weight-bold" style="color: white">I
                    </span>
                    {{ sectionTitle }}
                </p>
                <p class="bannerTitle2">
                    {{ sectionSubtitle }}
                </p>
                <br v-if=sectionSubtitleSecondPara>
                <p v-if=sectionSubtitleSecondPara class="bannerTitle2">
                    {{ sectionSubtitleSecondPara }}
                </p>
                <div v-if=buttonBool class="ef-btn-banner-section">
                    <div class="d-block d-md-inline-block">
                        <RequestDemo :imageBool="false" :buttonText="buttonText" :AITool="AITool" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RequestDemo from "@/components/RequestDemo.vue"
export default {
    methods: {
        closeModal() {
            this.$bvModal.hide('how-it-works')
        }
    },
    props: {
        sectionTitle: {
            type: String,
            default: null,
        },
        sectionSubtitle: {
            type: String,
            default: null,
        },
        sectionSubtitleSecondPara: {
            type: String,
            default: "",
        },
        imagePath: {
            type: String,
            default: null,
        },
        mobileImagePath: {
            type: String,
            default: null,
        },
        buttonBool: {
            type: Boolean,
            default: null,
        },
        AITool: {
            type: Boolean,
            default: false,
        },
        bannerHeight: {
            type: String,
            default: "70vh !important",
        },
        textHeight: {
            type: String,
            default: "50% !important",
        },
        buttonText: {
            type: String,
            default: "REQUEST A DEMO",
        },
    },
    components: {
        RequestDemo
    },
};

</script>

<style lang="scss" scoped>
.banner-section {
    position: relative;
    overflow: hidden;
    margin: 0;
    width: 100%;
    display: block;
}

.banner-container {
    position: relative;
    height: 70vh;

    img {
        object-fit: cover !important;
        height: 100%;
        overflow: hidden;
        filter: brightness(50%);
    }
}

.bannerTextContainer {
    position: absolute;
    z-index: 999;
    color: white;
    top: 50%;
    left: 10vw;
    text-align: left;
    transform: translateY(-50%);
}

.bannerCopy {
    font-size: 25px;

    p {
        font-family: "Poppins";
    }
}

.title-off {
    transform: translateX(-30px);
}

.bannerTitle1 {
    font-size: 1.8em;
    letter-spacing: 1px;
    color: #73bc44;
    font-weight: bold;
}

.bannerTitle2 {
    font-size: 0.8em;
    letter-spacing: 1px;
}

.hide-btn-focus:focus {
    box-shadow: none !important;
}

.ef-btn-banner-section {
    width: 100%;
    right: 20%;
}

.ef-btn {
    border: 0 !important;
}

@media (min-width: 320px) and (max-device-width: 767px) {
    .banner-container {
        height: 50vh !important;
        width: 100%;

        img {
            object-fit: cover !important;
            height: 100%;
            overflow: hidden;
            filter: brightness(50%);
        }
    }

    .bannerTitle1 {
        font-size: 1.0em !important;
    }

    .bannerTitle2 {
        font-size: 0.5em !important;
    }

    .title-off {
        transform: translateX(-0px);
    }

    .ef-btn-banner-section {
        width: 100%;
        right: 20%;
    }
}

@media (min-width: 768px) and (max-device-width: 1023px) and (orientation: landscape) {

    .banner-container {
        height: 50vh !important;
        width: 100%;
    }

    .title-off {
        transform: translateX(-15px);
    }

    .bannerTitle1 {
        font-size: 0.9em !important;
    }

    .bannerTitle2 {
        font-size: 0.5em !important;
    }
}

@media (min-width: 1024px) and (max-device-width: 1440px) and (orientation: landscape) {
    .banner-container {
        height: 80vh !important;
        width: 100%;
    }

    .bannerTitle1 {
        font-size: 1.3em !important;
    }

    .bannerTitle2 {
        font-size: 0.7em !important;
    }


    .title-off {
        transform: translateX(-20px);
    }
}
</style>